import _ from 'lodash'
import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import { ProductState } from '@/modules/product/store'
import * as api from '@/modules/product/api'
import { MutationTypes } from '@/modules/product/store/mutations';
import { notify, Colors } from '@/modules/core/notification';
import ProductPagination from '@/modules/product/model/ProductPagination';

const actions: ActionTree<ProductState, RootState> = {

    /**
     * Carga una paginación de productos en base a los parémetros de state.paginationParams
     */
    loadPagination: async ({state, commit}) => {
        commit(MutationTypes.SetLoadingPagination, true)
        const params = state.paginationParams
        let pagination: ProductPagination

        try {
            pagination = await api.getProductPagination(state.paginationParams)
        } catch (error) {
            notify('Se ha producido un error al carga la lista de productos', Colors.Error)
            commit(MutationTypes.SetLoadingPagination, false)

            return
        }

        commit(MutationTypes.SetProductPagination, pagination)
        commit(MutationTypes.SetLoadingPagination, false)
    },

    /**
     * Carga un producto
     */
    loadProduct: async ({commit, dispatch}, id: string) => {
        // Carga la lista de idiomas de Unigest
        await dispatch('loadUnigestLanguages')

        const product = await api.getProduct(id)
        commit(MutationTypes.SetCurrentProduct, product)
        commit(MutationTypes.SetCurrentLocale, 'es')

        // Carga el reporte de análisis SEO de la publicación
        dispatch('seo/loadSEOAnalysisReport', null, { root: true })
    },

    loadLargeImage: async ({state, commit}) => {
        const data = await api.getProductImage(state.currentProduct.id)
        commit(MutationTypes.UpdateProductField, {path: 'largeImage', value: data})
    },

    /**
     * Sube una imagen del producto al servidor
     */
    uploadProductImage: async ({state, commit}, data: string) => {
        await api.uploadProductImage(state.currentProduct.id, data)

        commit(MutationTypes.UpdateProductField, {path: 'image', value: data})
        commit(MutationTypes.UpdateProductField, {path: 'largeImage', value: data})

        notify('La imagen del producto se ha actualizado correctamente', Colors.Success)
    },

    /**
     * Actualiza el producto actualmente en edición
     */
    updateProduct: async ({state, commit, rootState, dispatch}) => {

        // Actualiza el SEO del producto
        commit(MutationTypes.UpdateProductField, { path: 'seo', value: _.get(rootState, 'seo.currentMetadata')})

        const product = await api.updateProduct(state.currentProduct)

        commit(MutationTypes.SetCurrentProduct, product)
        commit(MutationTypes.ShowSaveConfirm, false)

        notify(`El producto ${product.id} se ha actualizado correctamente`, Colors.Success, {
            goToAction: {
                buttonName: 'Ver producto',
                route: {
                    name: 'product.detail',
                    params: { id: product.id.toString() },
                },
            },
        });

        // Carga el reporte de análisis SEO de la publicación
        dispatch('seo/loadSEOAnalysisReport', null, { root: true })
    },

    /**
     * Carga en el estado la lista de idiomas registrados en Unigest
     */
    loadUnigestLanguages: async ({state, commit}) => {
        if (state.unigestLanguages.length) {
            return
        }

        const languages = await api.getUnigestLanguages()
        commit(MutationTypes.SetUnigestLanguages, languages)
    },
}

export default actions
